import validate from "/home/tickets-hzbmt/tickets.muzieum.nl/node_modules/nuxt/dist/pages/runtime/validate.js";
import nav_45global from "/home/tickets-hzbmt/tickets.muzieum.nl/client/middleware/nav.global.js";
export const globalMiddleware = [
  validate,
  nav_45global
]
export const namedMiddleware = {}